export default "__VITE_ASSET__b647538d__"